<template>
  <div class="flex w-full items-baseline justify-center">
    <span class="loading loading-spinner loading-xl"></span>
  </div>
</template>
